import { render, staticRenderFns } from "./Modal2FA.vue?vue&type=template&id=84d4d75c&scoped=true"
import script from "./Modal2FA.vue?vue&type=script&lang=js"
export * from "./Modal2FA.vue?vue&type=script&lang=js"
import style0 from "./Modal2FA.vue?vue&type=style&index=0&id=84d4d75c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d4d75c",
  null
  
)

export default component.exports